import React from 'react';
import { IShapeProps } from './types';
import { Rect } from 'react-konva';
import Konva from 'konva';

const RectangleCanvasElement: React.FC<IShapeProps> = (props) => {
  
  const shapeRef = (props.shapeRef as React.MutableRefObject<Konva.Rect>);
  
  return (
    <Rect
      {...props.renderProps}
      ref={shapeRef}
    />
  );
};

export default RectangleCanvasElement;